import { createGlobalStyle } from "styled-components";
import {bg_color1, color1} from '@/styles/theme'
import jxl from '@/img/user-new/jxl.png'

export const GlobalStyle = createGlobalStyle`
* {
  // scrollbar-width: none;  
    scrollbar-width: none;  
}
    
::-webkit-scrollbar {
    display: none;
}
body {
  margin: 0;
  padding: 0;
  height: 100%;
  background-color: ${bg_color1}!important;
  user-select: none;
  color: ${color1};
  scrollbar-width: none;  
  input{
    user-select: auto;
  }
}
div,p,span, ul,li, table,ol{
  // font-family: "PingFang SC"!important;
}
ul, li, ol {
  margin: 0;
  padding: 0;
  list-style: none;
}

.flex-center {
  display: flex;
  align-items: center;
}
.flex-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
img {
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* 普通的CSS */
  }
  
@supports (bottom: env(safe-area-inset-bottom)){
  body,.footer,.model {
    /* padding-bottom: env(safe-area-inset-bottom)!important; */
  }
}

 @supports (bottom: constant(safe-area-inset-bottom)){
  body,.footer,.model {
    padding-bottom: constant(safe-area-inset-bottom)!important;
  }
}
body :global(.am-tabs-pane-wrap){
  overflow: visible;
}

.buyContentModal  {
  z-index: 9999;
  align-items: flex-end;
}

.buyContentModal .am-modal-transparent {
  // width: calc(294px);
  // max-width: calc(100vw - 80px);
  width: 100vw;
  .am-modal-content {
    border-radius: 7px 7px 0 0;
  }
}



.un-desc-modal {
  width: 84vw;
  .am-modal-header {
    padding-left: 0;
    padding-right: 0;
  }
  .am-modal-content {
    border-radius: 0;
    padding-top: 10px;
    background-color: transparent;
    overflow: visible;
    .am-modal-body {
      padding: 0;
      background-color: #fff;
      border-radius: 8px;
      background-image: url(${jxl});
      background-repeat: no-repeat;
      background-size: 316px auto;
      background-position: bottom right;
      padding: 38px 26px 45px;
    }
  }
  &.un-desc-modal2  .am-modal-content  .am-modal-body{
   background-image: none;
   padding-bottom: 20px;

  }
}


.un-prize-modal {
  width: calc(100vw - 60px);
  .am-modal-content {
    border-radius: 0;
    padding-top: 10px;
    background-color: transparent;
    overflow: visible;
    .am-modal-body {
      padding: 0;
      background-color: #ffefe6;
      border-radius: 8px;
      padding: 0;
    }
  }
}
.un-prize-modal.blue {
  .am-modal-body {
    background-color: #dce9fa;
  }
}
.regist-modal{
  width: 84vw;
  .am-modal-content {
    border-radius: 0;
    padding-top: 10px;
    background-color: transparent;
    overflow: visible;
    .am-modal-body {
      padding: 50px 16px 28px;
      background-color: #fff;
      border-radius: 8px;
      overflow: unset;
    }
  }
}
.regist-modal.regist-modal_match{
  width: 84vw;
  .am-modal-content {
    border-radius: 0;
    padding-top: 10px;
    background-color: transparent;
    overflow: visible;
    .am-modal-body {
      background-color: #fff;
      padding: 0;

      border-radius: 8px;
    }
  }
}
.am-toast-notice-content{
  .am-toast-text{
    background-color: rgba(0, 0, 0, .75);
    color: #e7e7e7;
  }
}

/**
 * 拉新渠道活动的弹框活动说明
 */
.lx-desc-modal-outer {
  align-items: center;
  .lx-desc-modal {
    top: 15vw;
  }

  .long-modal {
    .am-modal-body {
      padding: 38px 0px 65px;
      // overflow: scroll;
    }
  }
  .lx2-desc-modal {
    top: 50vw;
    transform: translateY(-50%) !important;
    .am-modal-body {
      padding: 0px;
    }
  }
  .am-modal-content {
    padding: 0px;
  }
}

.rw-desc-modal-outer{
  transform: none;
  .lx-desc-modal{
    width: calc(100% - 20px);
    .am-modal-title {
      transform: translateY(-47px)
    }
   
    .am-modal-content {
      text-align: inherit;
      border-radius:0 8px 8px 8px;
      position: relative;
      // background: linear-gradient(45deg, red 0%,red 50%,white 51%,white 100%);
      background: linear-gradient(135deg, #FFD637 0%,#FFD637 20px,white 22px,white 100%);
      padding-top: 0px;
     
      overflow: visible;
      .am-modal-body {
        position: relative;
        z-index: 10;
        // border-radius: 30px 0  0 0;
        padding: 0;
        overflow: visible;
      }
    }
  }
}
.am-modal-mask {
  background-color:rgba(0,0,0,0.6)
}
`

